module.exports = __webpack_public_path__ + "./images/tier4.jpg";